<template>
  <a-modal
    :title="formTitle || '新增'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
    >
      <a-form-item label="位置" name="type">
        <a-select v-model:value="form.type" placeholder="请选择位置">
          <a-select-option :key="0">心得</a-select-option>
          <a-select-option :key="2">启动页</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="标题" name="title">
        <a-input
          v-model:value="form.title"
          :maxLength="255"
          placeholder="请输入标题"
        />
      </a-form-item>
      <a-form-item label="内容" name="content">
        <editor v-model:value="form.content" />
      </a-form-item>
      <a-form-item label="跳转类型" name="linkType">
        <a-select v-model:value="form.linkType" placeholder="请选择跳转类型">
          <a-select-option :key="0">不跳转</a-select-option>
          <a-select-option :key="3">外链</a-select-option>
        </a-select>
      </a-form-item>
      <!--      <a-form-item label="跳转ID" name="link" >
              <a-input v-model:value="form.link" placeholder="请输入跳转ID" />
            </a-form-item>-->
      <a-form-item
        label="外部链接地址"
        v-if="form.linkType == 3"
        name="linkUrl"
      >
        <a-input
          v-model:value="form.linkUrl"
          :maxLength="255"
          placeholder="请输入外部链接地址"
        />
      </a-form-item>
      <a-form-item label="轮播图" name="imgUrl">
        <file-upload
          v-model:value="form.imgUrl"
          type="image"
          @change="changeSwiper"
        ></file-upload>
      </a-form-item>

      <!--      <a-form-item label="是否显示 1显示 0-不显示" name="isVisible" >
            </a-form-item>-->
      <a-form-item label="排序" name="sort">
        <a-input-number
          v-model:value="form.sort"
          style="width: 100%"
          :min="0"
          :step="1"
          :max="429496729"
          placeholder="请输入排序"
        />
      </a-form-item>
      <!--      <a-form-item label="备注" name="remark" >
              <a-input v-model:value="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
            </a-form-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import { getBanner, addBanner, updateBanner } from '@/api/banner/banner'
import Editor from '@/components/Editor'

const emit = defineEmits(['ok'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const formType = ref(1)
const open = ref(false)

const form = reactive({
  id: null,
  type: null,
  title: null,
  content: null,
  link: null,
  linkUrl: null,
  imgUrl: null,
  linkType: null,
  isVisible: 1,
  sort: 0,
  createTime: null,
  remark: null,
})

const rules = {
  imgUrl: [
    { required: true, message: '轮播图url不能为空', trigger: 'blur' },
  ],
  sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
}

function changeSwiper(e) {
  console.log(e)
  form.imgUrl = e
}

function onClose() {
  open.value = false
}

function cancel() {
  open.value = false
  reset()
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    type: null,
    title: null,
    content: null,
    link: null,
    linkUrl: null,
    imgUrl: null,
    linkType: null,
    isVisible: 1,
    sort: 0,
    createTime: null,
    remark: null,
  })
  nextTick(() => {
    if (formRef.value) {
      formRef.value.resetFields()
    }
  })
}

function handleAdd(row) {
  reset()
  formType.value = 1
  open.value = true
  formTitle.value = '添加'
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  const id = row ? row.id : ids
  getBanner({ id: id }).then((response) => {
    Object.assign(form, response.data)
    open.value = true
    formTitle.value = '修改'
  })
}

async function submitForm() {
  try {
    await formRef.value.validate()
    submitLoading.value = true
    if (form.id !== undefined && form.id !== null) {
      const response = await updateBanner(form)
      if (response.success) {
        message.success('修改成功', 3)
        open.value = false
        emit('ok')
      }
    } else {
      const response = await addBanner(form)
      if (response.success) {
        message.success('新增成功', 3)
        open.value = false
        emit('ok')
      }
    }
  } catch (error) {
    return false
  } finally {
    submitLoading.value = false
  }
}

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0 !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 60px 24px !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
}

/* Label 文字左对齐，与输入框左边对齐 */
.create-form-modal .ant-form-item-label {
  padding-right: 0 !important;
  text-align: left !important;
}

.create-form-modal .ant-form-item-label > label {
  text-align: left !important;
  justify-content: flex-start !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 确保表单项不会超出 */
.create-form-modal .ant-form-item {
  margin-bottom: 24px !important;
  overflow: visible !important;
  width: 100% !important;
  max-width: 100% !important;
}

.create-form-modal .ant-form-item-control {
  max-width: 100% !important;
  overflow: hidden !important;
  width: 100% !important;
}

/* 富文本编辑器外层容器 - 防止超出 */
.create-form-modal .ant-form-item-control-input-content {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}
</style>
